import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReports = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.3 0H14.5C13.9 0 13.5 0.4 13.5 1V5H7.8C7.2 5 6.8 5.4 6.8 6V10H1C0.4 10 0 10.4 0 11V21C0 21.6 0.4 22 1 22H21.3C21.9 22 22.3 21.6 22.3 21V1C22.3 0.4 21.8 0 21.3 0ZM2 12H6.8V20H2V12ZM8.8 7H13.6V20H8.8V7ZM20.3 20H15.5V2H20.3V20Z",
		fill: "white"
	})
});
export default SvgReports;
